import moment from 'moment'; // TODO: заменить moment на условный date-fns

const TIMEZONE_OFFSET = new Date().getTimezoneOffset() * 60 * 1000 * -1;

export const formatDateTZ = (
  date?: number | string,
  pattern: string = 'DD.MM.YYYY HH:mm',
  timezone: number = TIMEZONE_OFFSET
): string => {
  if (!date || !moment(date).isValid()) return '';
  return moment(moment(date).valueOf() + timezone).format(pattern);
};

export const formatDateToISO = (date: string) => {
  if (!date) return '';
  return moment(date, ['DD-MM-YYYY', 'YYYY-MM-DD', 'DD.MM.YYYY']).format(
    'YYYY-MM-DD'
  );
};
